import React, { useEffect, useState, useRef } from "react";
import { Container } from "./style";
import Home from './home-page';
import Page1 from "./page1";
import Page2 from "./page2";
import Page3 from "./page3";
import Page4 from "./page4";
import Rank from "./rank";
import DescIcon from './../activity_80/components/DescIcon'
import ReadArchive from './read-archive';

import { connect } from 'react-redux';
import { getActivityUserInfo } from '@/api/user-new';
import { getUserStatus, recoverArchive } from './api';
import h5Share from '@/utils/h5Share'

const active_id = 24;

const StockGame = ({ token }) => {
  const [step, setStep] = useState(0);
  const [uniqueCode, setUniqueCode] = useState(undefined);
  const [mode, setMode] = useState(null);
  const [activityInfo, setActivityInfo] = useState({user: {}});
  const [playResultInfo, setPlayResultInfo] = useState({});

  const [isReadArchive, setIsReadArchive] = useState(false);
  const [archiveInfo, setArchiveInfo] = useState({});
  
  const isToRankRef = useRef();

  const isLogin = !!token;

  const loaded = useRef(false);

  useEffect(() => {
    if (isLogin) {
      if (loaded.current) {
        return;
      }
      getActivityUserInfo(active_id).then(res => {
        if(!res.user) {
          res.user = {}
        }
        setActivityInfo(res);
      })

      getUserStatus({}).then(res => {
        if (res.status === 'finish') {
          setStep(3);
        }

        if (res.status === 'archive') {
          setArchiveInfo(res);
          setStep(-1);
        }

        loaded.current = true;
      })
    }
  }, [token]);

  useEffect(() => {
    h5Share.main({ 
      title: `牛回！速来股神模拟器！`,
      desc: '假如2023重来，试试你炒股能赚多少钱',
      link: process.env.REACT_APP_DEMAND_URL + 'active_31',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo7.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo7.png'
        }
      }
    })
  }, []);

  const handleReadArchive = () => {
    recoverArchive({ uniqueCode }).then(res => {
      setMode(archiveInfo.mode);
      setIsReadArchive(true);
      setStep(2);
    });
  }

  const handleToRank = () => {
    isToRankRef.current = true;
    setStep(5);
  }

  const homeNext = () => {
    isToRankRef.current = false;
    setStep(1)
  }

  const handleRankBack = () => {
    if (isToRankRef.current) {
      setStep(0)
    } else {
      setStep(3)
    }
  }

  const handleReplay = () => {
    setStep(1);
  }

  const handleExit = () => {
    setIsReadArchive(false)
    setArchiveInfo({});
    setStep(3)
  }

  return <Container>
    {step === -1 && <ReadArchive replay={handleReplay} readArchive={handleReadArchive} archiveMonth={archiveInfo.archiveMonth}  />}
    {step === 0 && <Home isLogin={isLogin} toRank={handleToRank} next={homeNext} />}
    {step === 1 && <Page1 activityInfo={activityInfo} next={() => setStep(step + 1)} setUniqueCode={setUniqueCode} setMode={setMode}/>}
    {step === 2 && 
      <Page2
        exit={handleExit}
        step={step}
        mode={mode}
        activityInfo={activityInfo}
        next={() => setStep(step + 1)}
        uniqueCode={uniqueCode}
        archiveInfo={archiveInfo}
        isReadArchive={isReadArchive}
      />
    }
    {step === 3 && 
      <Page3 
        setPlayResultInfo={setPlayResultInfo}
        activityInfo={activityInfo}
        next={() => setStep(step + 1)}
        mode={mode}
        toRank={() => setStep(5)}
        uniqueCode={uniqueCode}
        playAgain={() => setStep(0)}
      />
    }
    {step === 4 && 
      <Page4
        next={() => setStep(0)}
        uniqueCode={uniqueCode}
        playResultInfo={playResultInfo}
        back={() => setStep(3)}
      />
    }
    {step === 5 && 
      <Rank
        next={() => setStep(0)}
        back={handleRankBack}
        uniqueCode={uniqueCode}
      />
    }
    {
      step === 3  &&   <DescIcon />
    }
    
  </Container>;
}

const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(StockGame));


// WEBPACK FOOTER //
// ./src/views/activity_31/index.js